var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "220px" }
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleTabsClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "商家基本信息", name: "first" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商家id" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_id", $$v)
                      },
                      expression: "form.supply_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家名称" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_name", $$v)
                      },
                      expression: "form.supply_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家性质", prop: "supply_character" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "商家性质", disabled: true },
                      model: {
                        value: _vm.form.supply_character,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_character", $$v)
                        },
                        expression: "form.supply_character"
                      }
                    },
                    _vm._l(_vm.supply_character_type, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.supplyCharacterVisible = true
                        }
                      }
                    },
                    [_vm._v("\n          修改\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否可刷单", prop: "is_scal" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "是否可刷单" },
                      model: {
                        value: _vm.form.is_scal,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_scal", $$v)
                        },
                        expression: "form.is_scal"
                      }
                    },
                    _vm._l(_vm.is_scal_options, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家状态", prop: "supply_status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "商家状态", disabled: "" },
                      on: { change: _vm.changeStatus },
                      model: {
                        value: _vm.form.supply_status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_status", $$v)
                        },
                        expression: "form.supply_status"
                      }
                    },
                    _vm._l(_vm.supply_status, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: { type: "primary", size: "default" },
                      on: {
                        click: function($event) {
                          _vm.supplyStatusFormModalVisible = true
                        }
                      }
                    },
                    [_vm._v("修改")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "修改商家状态",
                    visible: _vm.supplyStatusFormModalVisible,
                    width: "30%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.supplyStatusFormModalVisible = $event
                    },
                    close: _vm.handleSupplyStatusModalClose
                  }
                },
                [
                  _vm.form.supply_status.toString() === "0"
                    ? _c("div", [
                        _vm._v("\n          当前商家状态为"),
                        _c("span", { staticStyle: { color: "#f56c6c" } }, [
                          _vm._v("「禁用」")
                        ]),
                        _vm._v("，需要改成"),
                        _c("span", { staticStyle: { color: "#67c23a" } }, [
                          _vm._v("「启用」")
                        ]),
                        _vm._v("？\n        ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.supply_status.toString() === "1"
                    ? _c("div", [
                        _vm._v("\n          当前商家状态为"),
                        _c("span", { staticStyle: { color: "#67c23a" } }, [
                          _vm._v("「启用」")
                        ]),
                        _vm._v("，需要改成"),
                        _c("span", { staticStyle: { color: "#f56c6c" } }, [
                          _vm._v("「禁用」")
                        ]),
                        _vm._v("？\n        ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "supplyStatusFormRef",
                      attrs: {
                        model: _vm.supplyStatusForm,
                        rules: _vm.supplyStatusFormRules,
                        "label-width": "120px",
                        inline: false,
                        "label-position": "top",
                        size: "normal"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "请填写备注（必填）", prop: "remark" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "属于审计监控内容，请如实填报！"
                            },
                            model: {
                              value: _vm.supplyStatusForm.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.supplyStatusForm, "remark", $$v)
                              },
                              expression: "supplyStatusForm.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.handleSupplyStatusModalClose } },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSupplyStatusModalConfirm }
                        },
                        [_vm._v("\n            确定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "提示",
                    visible: _vm.statusVisible,
                    width: "30%",
                    "before-close": _vm.handleClose
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.statusVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _vm.form.supply_status == 0
                        ? _c("p", [
                            _c("i", {
                              staticClass: "el-icon-warning",
                              staticStyle: { color: "orange" }
                            }),
                            _vm._v(
                              " 禁用后，该品牌下的所有商品将变为“断货”状态\n            "
                            ),
                            _vm.baobmobile
                              ? _c("span", [
                                  _vm._v("，商家爆版一手功能权限将关闭！")
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "请填写备注" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "备注", type: "textarea" },
                            model: {
                              value: _vm.form.status_remark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "status_remark", $$v)
                              },
                              expression: "form.status_remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.statusVisible = false
                              _vm.form.supply_status = 1
                            }
                          }
                        },
                        [_vm._v("\n            取 消\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.statusVisible = false
                            }
                          }
                        },
                        [_vm._v("\n            确 定\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "交易方式", prop: "settle_type" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "flex-direction": "row" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "交易方式",
                                disabled: true
                              },
                              model: {
                                value: _vm.form.settle_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "settle_type", $$v)
                                },
                                expression: "form.settle_type"
                              }
                            },
                            _vm._l(_vm.settle_type, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.settle_type == 2
                        ? _c("supply-select", {
                            attrs: {
                              data: {
                                is_signed_contract: _vm.form.is_signed_contract,
                                settle_days: _vm.form.settle_days
                              }
                            },
                            on: { returnData: _vm.returnData }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "支付方式", prop: "is_self" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true, placeholder: "支付方式" },
                      model: {
                        value: _vm.form.pay_method,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pay_method", $$v)
                        },
                        expression: "form.pay_method"
                      }
                    },
                    _vm._l(_vm.options.pay_methods, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handlePayMethodExchange }
                    },
                    [
                      _vm._v(
                        "\n          切换至" + _vm._s(_vm.otherPay.label || "")
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合并账单日期", prop: "bill_merger_date" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { multiple: "", placeholder: "合并账单日期" },
                      model: {
                        value: _vm.form.bill_merger_date,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "bill_merger_date", $$v)
                        },
                        expression: "form.bill_merger_date"
                      }
                    },
                    _vm._l(_vm.Date_list, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "select-option-tips" }, [
                    _vm._v(
                      "\n          填写后，商家前置仓账单会根据每月已填写的日期进行自动合并。\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "活动费扣取方式",
                    prop: "activity_fee_buckle"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.form.activity_fee_buckle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "activity_fee_buckle", $$v)
                        },
                        expression: "form.activity_fee_buckle"
                      }
                    },
                    [_vm._v("\n          账单方式\n        ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "activity-free-buckle-span" }, [
                    _vm._v("选择此结算方式，商家活动费在账单中扣取。")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.form.activity_fee_buckle === "1"
                        ? _c("el-switch", {
                            attrs: {
                              "active-value": "1",
                              "inactive-value": "2"
                            },
                            model: {
                              value: _vm.form.open_qz_auto_buckle,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "open_qz_auto_buckle", $$v)
                              },
                              expression: "form.open_qz_auto_buckle"
                            }
                          })
                        : _vm._e(),
                      _vm._v("\n          前置仓账单扣取\n          "),
                      _c("span", { staticClass: "open-qz-span" }, [
                        _vm._v(
                          "\n            *若开启，则活动费抵扣可在前置仓代采订单中扣取，否则前置仓代采订单不自动扣取活动费。\n          "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.is_platform !== _vm.constantMap.isPlatform
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "is_return_profit" } },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              "\n            折扣让利（佣金）\n            "
                            ),
                            _c("el-tooltip", { attrs: { effect: "light" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    "\n                商家签订折扣让利协议后，按月销量达标的商品由商家让利给一手平台。\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("i", { staticClass: "el-icon-question" })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.is_return_profit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "is_return_profit", $$v)
                              },
                              expression: "form.is_return_profit"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v(" 参与 ")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v(" 不参与 ")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.is_return_profit === _vm.constantMap.isJoinProfit
                      ? [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "让利账单生成周期 ",
                                prop: "period_profit",
                                required: ""
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  model: {
                                    value: _vm.form.period_profit,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "period_profit", $$v)
                                    },
                                    expression: "form.period_profit"
                                  }
                                },
                                _vm._l(_vm.periodProfitStatus, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n              如商家当前已经参与此协议，在切换账期模式后，本月仍保持旧的账期规则，直到下个月1号才会按新设置生效。若商家没参加过协议，或协议关闭已经超过一个月了，则马上生效。\n            "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "生效时间",
                                prop: "return_profit_month",
                                rules: _vm.commonRules.ruleChange
                              }
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "picker-options":
                                    _vm.constantMap.pickerOptions,
                                  type: "date",
                                  size: "small",
                                  "value-format": "yyyy-MM-dd",
                                  placeholder: "选择生效时间"
                                },
                                model: {
                                  value: _vm.form.return_profit_month,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "return_profit_month",
                                      $$v
                                    )
                                  },
                                  expression: "form.return_profit_month"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticStyle: { color: "gray" } }, [
                                _vm._v(
                                  "\n              在生效日期起代采开单且发货出库的商品将进行让利销量统计，历史数据请在让利销量汇总表补生成\n            "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "结算方式",
                                prop: "clearing_form",
                                rules: _vm.commonRules.ruleChange
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.clearing_form,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "clearing_form", $$v)
                                    },
                                    expression: "form.clearing_form"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v(" 代采单抵扣 ")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v(" 账单支付 ")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商品名单",
                                prop: "return_profit_goods_type",
                                rules: _vm.commonRules.ruleChange
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.return_profit_goods_type,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "return_profit_goods_type",
                                        $$v
                                      )
                                    },
                                    expression: "form.return_profit_goods_type"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v(" 所有商品 ")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v(" 指定货号 ")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-upload",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.form.return_profit_goods_type ===
                                        "2",
                                      expression:
                                        "form.return_profit_goods_type === '2'"
                                    }
                                  ],
                                  ref: "goodsTypeFileRef",
                                  staticStyle: {
                                    margin: "0 10px 2px",
                                    display: "flex"
                                  },
                                  attrs: {
                                    action: _vm.actionFile,
                                    name: "file",
                                    data: _vm.uploadParm,
                                    limit: 1,
                                    "on-exceed": _vm.limitTips,
                                    "on-success": _vm.importFile,
                                    "file-list": _vm.goodsTypeFile,
                                    "auto-upload": "",
                                    "with-credentials": ""
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" }
                                    },
                                    [_vm._v("上传文件")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商品要求",
                                prop: "reserve_price",
                                rules: _vm.commonRules.ruleBlur
                              }
                            },
                            [
                              _c(
                                "YsInput",
                                {
                                  staticStyle: { "min-width": "50%" },
                                  attrs: { pattern: "money", size: "small" },
                                  model: {
                                    value: _vm.form.reserve_price,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "reserve_price", $$v)
                                    },
                                    expression: "form.reserve_price"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "prepend" },
                                      slot: "prepend"
                                    },
                                    [_vm._v(" 非特价、且商家价> ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "append" },
                                      slot: "append"
                                    },
                                    [_vm._v("元/件")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "让利单价设置",
                                prop: "return_profit_rule",
                                rules: [_vm.commonRules.ruleChangeArray]
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleReturnProfitRuleAdd }
                                },
                                [
                                  _vm._v(
                                    "\n              添加设置行\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.form.return_profit_rule,
                                    border: "",
                                    size: "mini"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "序号",
                                      width: "80"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var $index = ref.$index
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s($index + 1) +
                                                  "\n                "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3878754635
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "num",
                                      align: "center",
                                      label:
                                        "月度销售件数达标门槛（按商品货号）"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            var $index = ref.$index
                                            return _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "return_profit_rule." +
                                                    $index +
                                                    ".num",
                                                  rules:
                                                    _vm.commonRules.ruleBlur
                                                }
                                              },
                                              [
                                                _c(
                                                  "YsInput",
                                                  {
                                                    attrs: {
                                                      pattern: "positiveInt",
                                                      size: "small"
                                                    },
                                                    model: {
                                                      value: row.num,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          row,
                                                          "num",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "row.num"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          slot: "prepend"
                                                        },
                                                        slot: "prepend"
                                                      },
                                                      [_vm._v("达到")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          slot: "append"
                                                        },
                                                        slot: "append"
                                                      },
                                                      [_vm._v("件及以上时")]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      259575427
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "price",
                                      align: "center",
                                      label: "让利单价"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            var $index = ref.$index
                                            return _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "return_profit_rule." +
                                                    $index +
                                                    ".price",
                                                  rules: _vm.rulePrice
                                                }
                                              },
                                              [
                                                _c(
                                                  "YsInput",
                                                  {
                                                    attrs: {
                                                      pattern: "money",
                                                      size: "small"
                                                    },
                                                    model: {
                                                      value: row.price,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          row,
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "row.price"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          slot: "append"
                                                        },
                                                        slot: "append"
                                                      },
                                                      [_vm._v("元/件")]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      615513313
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "actions",
                                      align: "center",
                                      label: "操作",
                                      width: "100"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var $index = ref.$index
                                            return _c(
                                              "el-form-item",
                                              {},
                                              [
                                                _vm.form.return_profit_rule
                                                  .length > 1
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "danger",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleReturnProfitRuleDel(
                                                              $index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    删除\n                  "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4167733068
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家邀约规则设置" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "800px" },
                      attrs: {
                        data: _vm.invitationRule.rule,
                        border: "",
                        size: "mini"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "规则序号" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var $index = ref.$index
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s($index + 1) +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "invitation_category",
                          align: "center",
                          label: "商品分类"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "forecast_days",
                          align: "center",
                          label: "前置仓备货天数"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "is_underwriting",
                          align: "center",
                          label: "是否加流"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        scope.row.is_underwriting ===
                                          _vm.constantMap.OPEN
                                          ? "是"
                                          : "否"
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "no_pre_storage_forecast_days",
                          align: "center",
                          label: "非前置仓备货天数"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleInvitationRuleEdit }
                    },
                    [_vm._v("\n          编辑\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "城市 ", prop: "city" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "城市" },
                      on: {
                        change: function($event) {
                          return _vm.handleSelectCity($event, true)
                        }
                      },
                      model: {
                        value: _vm.form.city,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "city", $$v)
                        },
                        expression: "form.city"
                      }
                    },
                    _vm._l(_vm.citys, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "市场（地理位置）", prop: "father_market" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "市场" },
                      on: {
                        change: function($event) {
                          return _vm.setChild($event, true)
                        }
                      },
                      model: {
                        value: _vm.form.father_market,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "father_market", $$v)
                        },
                        expression: "form.father_market"
                      }
                    },
                    _vm._l(_vm.marketList, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.label, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "子市场（地理位置）", prop: "market_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "子市场" },
                      model: {
                        value: _vm.form.market_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "market_id", $$v)
                        },
                        expression: "form.market_id"
                      }
                    },
                    _vm._l(_vm.subMarketList, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.label, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "attributable_market_id" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _vm._v("\n          业绩归属市场\n          "),
                      _c("el-tooltip", { attrs: { effect: "light" } }, [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [_vm._v("用于统计公司内部各市场部门的业绩销售情况")]
                        ),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-question" })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "业绩归属市场" },
                      on: {
                        change: function($event) {
                          return _vm.handleSetAttributableSubMarket(
                            $event,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.form.attributable_market_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "attributable_market_id", $$v)
                        },
                        expression: "form.attributable_market_id"
                      }
                    },
                    _vm._l(_vm.performanceMarketList, function(item) {
                      return _c("el-option", {
                        key: item.attributable_market_id,
                        attrs: {
                          label: item.attributable_market_name,
                          value: item.attributable_market_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "业绩归属细分市场",
                    prop: "attributable_market_sub_id"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "业绩归属细分市场"
                      },
                      model: {
                        value: _vm.form.attributable_market_sub_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "attributable_market_sub_id", $$v)
                        },
                        expression: "form.attributable_market_sub_id"
                      }
                    },
                    _vm._l(_vm.performanceSubMarketList, function(item) {
                      return _c("el-option", {
                        key: item.sub_id,
                        attrs: { label: item.sub_name, value: item.sub_id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "楼层", prop: "supply_floor" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "楼层" },
                      on: { change: _vm.genSupplyName },
                      model: {
                        value: _vm.form.supply_floor,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_floor", $$v)
                        },
                        expression: "form.supply_floor"
                      }
                    },
                    _vm._l(_vm.floor, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "区域/街", prop: "supply_area_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "区域/街" },
                      on: { change: _vm.genSupplyName },
                      model: {
                        value: _vm.form.supply_area_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_area_id", $$v)
                        },
                        expression: "form.supply_area_id"
                      }
                    },
                    _vm._l(_vm.supply_area_list, function(item) {
                      return _c("el-option", {
                        key: item.supply_area_id,
                        attrs: {
                          label: item.supply_area,
                          value: item.supply_area_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "档口号", prop: "supplier_num" } },
                [
                  _c("el-autocomplete", {
                    staticClass: "inline-input",
                    attrs: {
                      "fetch-suggestions": _vm.querySearch,
                      placeholder: "请输入档口号"
                    },
                    on: { select: _vm.handleSelect, blur: _vm.genSupplyName },
                    model: {
                      value: _vm.form.supplier_num,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supplier_num", $$v)
                      },
                      expression: "form.supplier_num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "一手商城档口名" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "显示于档口形象图上面的昵称（最多10个中文字）"
                    },
                    model: {
                      value: _vm.form.supply_nickname,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_nickname", $$v)
                      },
                      expression: "form.supply_nickname"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌", prop: "brand" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%", float: "left" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.brand,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "brand", $$v)
                      },
                      expression: "form.brand"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.brandVisible = true
                        }
                      }
                    },
                    [_vm._v(" 编辑 ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "代采组", prop: "pgid" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "代采组" },
                      on: { change: _vm.getMemberOption },
                      model: {
                        value: _vm.form.pgid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pgid", $$v)
                        },
                        expression: "form.pgid"
                      }
                    },
                    _vm._l(_vm.pg_list, function(item) {
                      return _c("el-option", {
                        key: item.pgid,
                        attrs: { label: item.pgname, value: item.pgid }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "代采员", prop: "pg_member_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "代采员" },
                      model: {
                        value: _vm.form.pg_member_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pg_member_id", $$v)
                        },
                        expression: "form.pg_member_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "全部" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.memberOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "次品组", prop: "dgid" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "次品组", filterable: "" },
                      on: { change: _vm.getDefectiveGroupMember },
                      model: {
                        value: _vm.form.dgid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dgid", $$v)
                        },
                        expression: "form.dgid"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.defectiveGroupOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "次品员", prop: "dg_member_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "次品组" },
                      model: {
                        value: _vm.form.dg_member_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dg_member_id", $$v)
                        },
                        expression: "form.dg_member_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.defectiveGroupMemberOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "售后退供员", prop: "refund_member_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "售后退供员" },
                      model: {
                        value: _vm.form.refund_member_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "refund_member_id", $$v)
                        },
                        expression: "form.refund_member_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.refundMemberOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "买手组", prop: "pg_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "买手组" },
                      on: { change: _vm.getPickerGroupMemberOption },
                      model: {
                        value: _vm.form.pg_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pg_id", $$v)
                        },
                        expression: "form.pg_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "无" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.pickers, function(item) {
                        return _c("el-option", {
                          key: item.pg_id,
                          attrs: { label: item.pg_name, value: item.pg_id }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "买手",
                    prop: "supply_picker_group_member_id"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "买手" },
                      model: {
                        value: _vm.form.supply_picker_group_member_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "supply_picker_group_member_id",
                            $$v
                          )
                        },
                        expression: "form.supply_picker_group_member_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "无" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.PickerGroupMemberOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家运营跟进人", prop: "follower" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "商家运营跟进人" },
                      model: {
                        value: _vm.form.follower_admin_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "follower_admin_id", $$v)
                        },
                        expression: "form.follower_admin_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.resData.follower || [], function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            disabled: item.admin_status == 0,
                            label: item.label,
                            value: item.value
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家拓展跟进人", prop: "follower" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "商家拓展跟进人" },
                      model: {
                        value: _vm.form.expand_admin_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "expand_admin_id", $$v)
                        },
                        expression: "form.expand_admin_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.resData.follower || [], function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            disabled: item.admin_status == 0,
                            label: item.label,
                            value: item.value
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家开发人", prop: "supply_developer" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "商家开发人",
                        disabled: _vm.current_developer != 0
                      },
                      model: {
                        value: _vm.form.supply_developer_admin,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_developer_admin", $$v)
                        },
                        expression: "form.supply_developer_admin"
                      }
                    },
                    _vm._l(_vm.supply_developer, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "前置仓跟进人", prop: "pre_storage_admin" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "前置仓跟进人" },
                      model: {
                        value: _vm.form.pre_storage_admin,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pre_storage_admin", $$v)
                        },
                        expression: "form.pre_storage_admin"
                      }
                    },
                    _vm._l(_vm.resData.pre_storage_admin_list, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品默认活跃值",
                    prop: "supply_action_value"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "45%" },
                    attrs: { placeholder: "商家新建商品默认活跃值" },
                    model: {
                      value: _vm.form.supply_action_value,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_action_value", $$v)
                      },
                      expression: "form.supply_action_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排单锁定天数", prop: "limit_day" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "number" },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function() {
                          return [_vm._v(" 天 ")]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.form.limit_day,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "limit_day", $$v)
                      },
                      expression: "form.limit_day"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "超时断计划", prop: "plan_time_out_days" } },
                [
                  _c("ys-input", {
                    staticStyle: { width: "200px" },
                    attrs: { pattern: "positiveInt", min: "1", max: "999" },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function() {
                          return [_vm._v(" 天 ")]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.form.plan_time_out_days,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "plan_time_out_days", $$v)
                      },
                      expression: "form.plan_time_out_days"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n          超过（大于）设定天数未开单且无客需的\n          "
                    ),
                    _c("span", { staticStyle: { color: "#f00" } }, [
                      _vm._v("系统计划")
                    ]),
                    _vm._v("\n          及\n          "),
                    _c("span", { staticStyle: { color: "#f00" } }, [
                      _vm._v("重采计划")
                    ]),
                    _vm._v("\n          （数量不足来源）以及\n          "),
                    _c("span", { staticStyle: { color: "#f00" } }, [
                      _vm._v("虚拟库存采购计划")
                    ]),
                    _vm._v("\n          自动断待开单。\n        ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "前置仓包销商品寄售期", prop: "" } },
                [
                  _c("ys-input", {
                    staticStyle: { width: "200px" },
                    attrs: { pattern: "int", min: "0" },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function() {
                          return [_vm._v(" 天 ")]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.form.pre_consignment_period,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pre_consignment_period", $$v)
                      },
                      expression: "form.pre_consignment_period"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v(" 提交 ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "品牌信息",
                    visible: _vm.brandVisible,
                    width: "60%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.brandVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "前端是否显示品牌名" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "inactive-color": "#ff4949",
                              "active-color": "#13ce66",
                              "inactive-value": "0",
                              "active-value": "1",
                              "inactive-text": "不显示",
                              "active-text": "显示"
                            },
                            model: {
                              value: _vm.form.is_show_brand,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "is_show_brand", $$v)
                              },
                              expression: "form.is_show_brand"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.form.brands, function(brand, index) {
                        return _c(
                          "el-form-item",
                          {
                            key: brand.brand_id + index,
                            attrs: {
                              label: "品牌" + (index + 1),
                              prop: "brands." + index + ".brand_name"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "left",
                                  "margin-right": "10px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              品牌id:" +
                                    _vm._s(brand.brand_id) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              staticStyle: { display: "none" },
                              attrs: { placeholder: "brand_id" },
                              model: {
                                value: brand.brand_id,
                                callback: function($$v) {
                                  _vm.$set(brand, "brand_id", $$v)
                                },
                                expression: "brand.brand_id"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticStyle: { width: "60%", float: "left" },
                              attrs: { placeholder: "品牌名" },
                              model: {
                                value: brand.brand_name,
                                callback: function($$v) {
                                  _vm.$set(brand, "brand_name", $$v)
                                },
                                expression: "brand.brand_name"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: index,
                                  disabled: brand.status != 1
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.genSupplyName()
                                  }
                                },
                                model: {
                                  value: _vm.form.is_main,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "is_main", $$v)
                                  },
                                  expression: "form.is_main"
                                }
                              },
                              [_vm._v("\n              主品牌\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: brand.status == 1 ? "success" : "danger"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.changeBrand(brand)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      brand.status == 1 ? "已启用" : "已禁用"
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.addBrand } }, [
                        _vm._v(" 增加品牌 ")
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.brandVisible = false
                            }
                          }
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.setBrand }
                        },
                        [_vm._v(" 确 定 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "商家性质",
                    visible: _vm.supplyCharacterVisible,
                    width: "60%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.supplyCharacterVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-left": "40px",
                        "margin-top": "20px"
                      }
                    },
                    _vm._l(_vm.supply_character_type, function(item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.value,
                          attrs: { label: item.value },
                          model: {
                            value: _vm.plan_supply_character,
                            callback: function($$v) {
                              _vm.plan_supply_character = $$v
                            },
                            expression: "plan_supply_character"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.label) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.handleResetSupplyCharacter } },
                        [_vm._v(" 取 消 ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSetSupplyCharacter }
                        },
                        [_vm._v("\n            确 定\n          ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "商家权限", name: "second" } },
            [
              _vm.activeName === "second"
                ? _c("limit-of-supply", {
                    attrs: {
                      "supply-data": _vm.form,
                      "refund-models": _vm.refundModels
                    },
                    on: { submit: _vm.limitOfSupplySubmit }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "none" },
                  attrs: {
                    label: "自主上款是否需要审核",
                    prop: "is_self_need_audit"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "自主上款是否需要审核",
                        disabled: true
                      },
                      on: { change: _vm.setSelfNeedAudit },
                      model: {
                        value: _vm.form.is_self_need_audit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_self_need_audit", $$v)
                        },
                        expression: "form.is_self_need_audit"
                      }
                    },
                    _vm._l(_vm.is_self_need_audit, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "平台化设置", name: "platforming", lazy: true } },
            [
              _c("platforming", {
                ref: "platforming",
                attrs: { "supply-id": _vm.form.supply_id }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "商家标签", name: "third" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "擅长季节", prop: "season" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { lable: "擅长季节" },
                      model: {
                        value: _vm.form.season,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "season", $$v)
                        },
                        expression: "form.season"
                      }
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "春季" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "夏季" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "秋季" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "冬季" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "适合年龄阶段", prop: "season" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.age_group,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "age_group", $$v)
                        },
                        expression: "form.age_group"
                      }
                    },
                    _vm._l(_vm.age_group_list, function(age) {
                      return _c(
                        "el-checkbox",
                        { key: age.key, attrs: { label: age.key } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(age.label) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "档次", prop: "supply_grade" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { lable: "档次" },
                      model: {
                        value: _vm.form.supply_grade,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_grade", $$v)
                        },
                        expression: "form.supply_grade"
                      }
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "低端" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "中低" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "中端" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "中高" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "高端" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "擅长品类" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      placeholder: "搜索品类",
                      options: _vm.category,
                      props: { multiple: true },
                      filterable: ""
                    },
                    model: {
                      value: _vm.form.cat_ids,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cat_ids", $$v)
                      },
                      expression: "form.cat_ids"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主要风格" } },
                [
                  _c("el-transfer", {
                    attrs: {
                      filterable: "",
                      titles: ["选项", "选中"],
                      "filter-placeholder": "请输入风格",
                      data: _vm.styles_data
                    },
                    on: { change: _vm.build_second_styles },
                    model: {
                      value: _vm.form.styles,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "styles", $$v)
                      },
                      expression: "form.styles"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "副风格" } },
                [
                  _c("el-transfer", {
                    attrs: {
                      filterable: "",
                      titles: ["选项", "选中"],
                      "filter-placeholder": "请输入风格",
                      data: _vm.second_styles_data
                    },
                    on: { change: _vm.build_styles },
                    model: {
                      value: _vm.form.second_styles,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "second_styles", $$v)
                      },
                      expression: "form.second_styles"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "推荐描述" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "40%", float: "left" },
                    attrs: { maxlength: "100" },
                    model: {
                      value: _vm.form.recommend_desc,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "recommend_desc", $$v)
                      },
                      expression: "form.recommend_desc"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "一手APP上的商家推荐描述（建议30字以内，否则在手机上超出的部分可能会变为省略号）"
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌介绍" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "40%", float: "left" },
                    attrs: { placeholder: "说点什么呢~" },
                    model: {
                      value: _vm.form.pg_say,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pg_say", $$v)
                      },
                      expression: "form.pg_say"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v(" 提交 ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: { label: "商家经营信息", name: "BusinessInfo", lazy: true }
            },
            [
              _vm.isShowManagement
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "微信联系方式" } },
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { span: 24 }
                          },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.wx_picture,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "wx_picture", $$v)
                                },
                                expression: "form.wx_picture"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "25%", float: "left" },
                          attrs: { placeholder: "录入微信号" },
                          model: {
                            value: _vm.form.wx_no,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "wx_no", $$v)
                            },
                            expression: "form.wx_no"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "联系方式" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "25%", float: "left" },
                          attrs: { placeholder: "手机" },
                          model: {
                            value: _vm.form.supply_mobile_phone,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "supply_mobile_phone", $$v)
                            },
                            expression: "form.supply_mobile_phone"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "25%", float: "left" },
                          attrs: { placeholder: "微信" },
                          model: {
                            value: _vm.form.supply_wechat,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "supply_wechat", $$v)
                            },
                            expression: "form.supply_wechat"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.form.payees, function(payee, index) {
                      return _c(
                        "el-form-item",
                        {
                          key: payee.key,
                          attrs: { label: "收款人信息" + (index + 1) }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%" },
                            attrs: {
                              disabled: "",
                              value:
                                payee.payee_name +
                                "-" +
                                payee.payee_bank +
                                "-" +
                                payee.cnap_name +
                                "-" +
                                payee.payee_bank_account
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: index },
                              on: {
                                change: function($event) {
                                  return _vm.setDefaultPayee(payee)
                                }
                              },
                              model: {
                                value: _vm.form.is_default,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "is_default", $$v)
                                },
                                expression: "form.is_default"
                              }
                            },
                            [_vm._v("\n            默认收款账号\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.updatePayee(payee)
                                }
                              }
                            },
                            [_vm._v(" 编辑 ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removePayee(payee)
                                }
                              }
                            },
                            [_vm._v(" 删除 ")]
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.updatePayee()
                          }
                        }
                      },
                      [_vm._v(" 增加收款人 ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "修改付款信息",
                          visible: _vm.savePayeeVisible,
                          width: "60%",
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.savePayeeVisible = $event
                          }
                        }
                      },
                      [
                        _c(
                          "el-form",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "收款人姓名" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "80%", float: "right" },
                                  attrs: { placeholder: "请输入收款人姓名" },
                                  model: {
                                    value: _vm.spayee.payee_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.spayee, "payee_name", $$v)
                                    },
                                    expression: "spayee.payee_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "收款人银行" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "80%",
                                      float: "right"
                                    },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "收款银行"
                                    },
                                    model: {
                                      value: _vm.spayee.payee_bank,
                                      callback: function($$v) {
                                        _vm.$set(_vm.spayee, "payee_bank", $$v)
                                      },
                                      expression: "spayee.payee_bank"
                                    }
                                  },
                                  _vm._l(_vm.banks, function(item) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "收款人支行" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "80%",
                                      float: "right"
                                    },
                                    attrs: {
                                      filterable: "",
                                      remote: "",
                                      "remote-method": _vm.setCnap,
                                      placeholder:
                                        "所属支行（若不确定，选用“xx营业部”或“xx分行”"
                                    },
                                    model: {
                                      value: _vm.spayee.cnap,
                                      callback: function($$v) {
                                        _vm.$set(_vm.spayee, "cnap", $$v)
                                      },
                                      expression: "spayee.cnap"
                                    }
                                  },
                                  [
                                    _c("el-option", { attrs: { value: "" } }, [
                                      _vm._v(" 请选择 ")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.cnaps, function(item) {
                                      return _c("el-option", {
                                        key: item.cnap,
                                        attrs: {
                                          label: item.cnap_name,
                                          value: item.cnap
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "收款人银行账号" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "80%", float: "right" },
                                  attrs: {
                                    placeholder: "请输入收款人银行账号"
                                  },
                                  model: {
                                    value: _vm.spayee.payee_bank_account,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.spayee,
                                        "payee_bank_account",
                                        $$v
                                      )
                                    },
                                    expression: "spayee.payee_bank_account"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.savePayeeVisible = false
                                  }
                                }
                              },
                              [_vm._v(" 取 消 ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.savePayee()
                                  }
                                }
                              },
                              [_vm._v(" 确 定 ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "身份证正面" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.front_id_card,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "front_id_card", $$v)
                                },
                                expression: "form.front_id_card"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "身份证反面" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.back_id_card,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "back_id_card", $$v)
                                },
                                expression: "form.back_id_card"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "待结算证明" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.settle_certificate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "settle_certificate", $$v)
                                },
                                expression: "form.settle_certificate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "档口线下实力分级" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "爆版店铺" },
                            model: {
                              value: _vm.form.supply_level,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "supply_level", $$v)
                              },
                              expression: "form.supply_level"
                            }
                          },
                          _vm._l(_vm.level_options, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "一手店铺底图" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.pic,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "pic", $$v)
                                },
                                expression: "form.pic"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "档口实拍图" } },
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { span: 24 }
                          },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin, limit: 9 },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.picture,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "picture", $$v)
                                },
                                expression: "form.picture"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-col", [
                          _c("span", { staticStyle: { color: "#999" } }, [
                            _vm._v(
                              "\n              单张图片不要超过10M，最多可上传9张图片\n            "
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "品牌logo" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: {
                                origin: _vm.origin,
                                "model-name": "avatar"
                              },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.avatar,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "avatar", $$v)
                                },
                                expression: "form.avatar"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "档口海报图" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.posters,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "posters", $$v)
                                },
                                expression: "form.posters"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "营业执照" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c("UploadCommonTemplate", {
                              attrs: { origin: _vm.origin },
                              on: { "preview-image": _vm.previewImage },
                              model: {
                                value: _vm.form.license,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "license", $$v)
                                },
                                expression: "form.license"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "工作室照片" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo",
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-right": "10px"
                                },
                                style: "width:100px;float:left;height:50px;",
                                attrs: {
                                  "show-file-list": false,
                                  action: _vm.uploadActionUrl,
                                  data: _vm.uploadData,
                                  multiple: "",
                                  accept: "image/*",
                                  "on-success": _vm.uploadSuccess,
                                  "on-remove": _vm.handleRemove,
                                  "before-upload": _vm.beforeStudioPhotosUpload,
                                  "on-exceed": _vm.handleExceed,
                                  "file-list": _vm.fileList,
                                  limit: 9,
                                  disabled: _vm.videoFlag,
                                  "on-change": _vm.handleChange,
                                  "on-error": _vm.handleError
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { margin: "10px 3px" },
                                    attrs: {
                                      size: "small",
                                      type: "primary",
                                      disabled: _vm.videoFlag
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                上传图片\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.form.studioPhotos.length > 0
                              ? _vm._l(_vm.form.studioPhotos, function(
                                  url,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: {
                                        float: "left",
                                        width: "50px",
                                        height: "50px",
                                        margin: "0 10px",
                                        border: "1px solid #ddd"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { position: "relative" }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "50px",
                                              height: "50px",
                                              cursor: "pointer"
                                            },
                                            attrs: { src: url },
                                            on: {
                                              click: function($event) {
                                                return _vm.previewStudioPhoto(
                                                  url
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "15px",
                                                height: "15px",
                                                position: "absolute",
                                                top: "-5px",
                                                right: "-5px",
                                                cursor: "pointer",
                                                display: "flex"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteImg(
                                                    url,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "15px",
                                                  height: "15px"
                                                },
                                                attrs: {
                                                  src:
                                                    _vm.origin +
                                                    "/201804/13/15235857625ad012e238658.png"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                })
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-col", [
                          _c("span", { staticStyle: { color: "#999" } }, [
                            _vm._v(
                              "\n              单张图片不要超过10M，最多可上传9张图片\n            "
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商家视频" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo",
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-right": "10px"
                                },
                                style: "width:100px;float:left;height:50px;",
                                attrs: {
                                  "show-file-list": false,
                                  action: _vm.uploadActionUrl,
                                  data: _vm.uploadData,
                                  multiple: "",
                                  accept: "video/*",
                                  "on-success": _vm.uploadSuccessVideo,
                                  "before-upload": _vm.beforeVideoUpload,
                                  "on-progress": _vm.uploadVideoProcess,
                                  "file-list": _vm.files
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { margin: "10px 3px" },
                                    attrs: { size: "small", type: "primary" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                上传视频\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.supply_video != ""
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      width: "50px",
                                      height: "50px",
                                      margin: "0 10px",
                                      border: "1px solid #ddd"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c("video", {
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px"
                                          },
                                          attrs: { src: _vm.supply_video },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleViewVideo(
                                                _vm.supply_video
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "15px",
                                              height: "15px",
                                              position: "absolute",
                                              top: "-5px",
                                              right: "-5px"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteVideo()
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "15px",
                                                height: "15px"
                                              },
                                              attrs: {
                                                src:
                                                  _vm.origin +
                                                  "/201804/13/15235857625ad012e238658.png"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.videoFlag == true
                              ? _c("el-progress", {
                                  staticStyle: { "margin-top": "30px" },
                                  attrs: {
                                    type: "circle",
                                    percentage: _vm.videoUploadPercent
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-col", [
                          _c("span", { staticStyle: { color: "#999" } }, [
                            _vm._v(
                              "\n              视频不要超过50M，最多可上传1个视频\n            "
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "合同/协议管理" } },
                      [
                        _c(
                          "el-col",
                          { style: "width:100%;", attrs: { span: 24 } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { margin: "10px 3px" },
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.addContractVisible = true
                                  }
                                }
                              },
                              [_vm._v("添加线下合同")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.contract.length > 0
                          ? _c(
                              "el-col",
                              { style: "width:100%;", attrs: { span: 24 } },
                              [
                                _vm.isContractUpdate
                                  ? _c(
                                      "el-table",
                                      {
                                        style: "width:800px;",
                                        attrs: {
                                          data: _vm.contract,
                                          border: "",
                                          size: "mini"
                                        }
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "sc_name",
                                            label: "合同名称",
                                            width: "180"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "name",
                                            label: "合同起始时间",
                                            width: "180"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          scope.row.start_time
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          scope.row.end_time
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1017381618
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: { label: "签署方式" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          scope.row.sc_type ===
                                                            _vm.OFFLINE_CONTART
                                                            ? "线下合同"
                                                            : "线上合同"
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            599487100
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "sign_time",
                                            label: "签署时间"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: { label: "操作" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticStyle: {
                                                          margin: "10px 3px"
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          type: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleContractDetail(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    查看合同\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticStyle: {
                                                          margin: "10px 3px"
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          type: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleContractDel(
                                                              scope.$index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    删除合同\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            668246550
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleManagementSubmit }
                          },
                          [_vm._v("\n            提交\n          ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: _vm.isLookContract ? "查看合同" : "添加合同",
                          visible: _vm.addContractVisible,
                          width: "40%",
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.addContractVisible = $event
                          },
                          close: _vm.handleContractCancel
                        }
                      },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "contractForm",
                            attrs: { model: _vm.contractForm }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "合同/协议名称", required: "" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "80%", float: "left" },
                                  attrs: {
                                    disabled: _vm.isLookContract,
                                    placeholder: "请输入合同/协议名称",
                                    maxlength: "20",
                                    "show-word-limit": ""
                                  },
                                  model: {
                                    value: _vm.contractForm.sc_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.contractForm, "sc_name", $$v)
                                    },
                                    expression: "contractForm.sc_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "合同签署时间", required: "" }
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    disabled: _vm.isLookContract,
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    placeholder: "选择合同签署时间"
                                  },
                                  model: {
                                    value: _vm.contractForm.sign_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contractForm,
                                        "sign_time",
                                        $$v
                                      )
                                    },
                                    expression: "contractForm.sign_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "起止时间", required: "" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    disabled: _vm.isLookContract,
                                    "default-time": ["00:00:00", "23:59:59"],
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.contractForm.create_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contractForm,
                                        "create_time",
                                        $$v
                                      )
                                    },
                                    expression: "contractForm.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "扫描件", required: "" } },
                              [
                                _c("UploadCommonTemplate", {
                                  attrs: {
                                    disabled: _vm.isLookContract,
                                    origin: _vm.origin,
                                    accept: "image/*,.pdf"
                                  },
                                  on: { "preview-image": _vm.previewImage },
                                  model: {
                                    value: _vm.contractForm.scan_image,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contractForm,
                                        "scan_image",
                                        $$v
                                      )
                                    },
                                    expression: "contractForm.scan_image"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.isLookContract &&
                                      _vm.contractForm.sc_type !==
                                        _vm.OFFLINE_CONTART,
                                    expression:
                                      "\n                isLookContract && contractForm.sc_type !== OFFLINE_CONTART\n              "
                                  }
                                ],
                                attrs: { label: "合同内容" }
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.contractForm.sc_content
                                    )
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              { on: { click: _vm.handleContractCancel } },
                              [_vm._v(" 取 消 ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.isLookContract
                                },
                                on: { click: _vm.handleContractAdd }
                              },
                              [_vm._v("\n              确 定\n            ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "爆版权限", name: "fourth" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "爆版手机账号" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "30%" },
                      attrs: {
                        disabled: !!_vm.baobmobile,
                        placeholder: "请输入手机账号"
                      },
                      model: {
                        value: _vm.form.baobmobile,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "baobmobile", $$v)
                        },
                        expression: "form.baobmobile"
                      }
                    },
                    [
                      !_vm.baobmobile
                        ? _c(
                            "el-button",
                            {
                              attrs: { slot: "append" },
                              on: { click: _vm.getShopList },
                              slot: "append"
                            },
                            [_vm._v("\n            获取店铺列表\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.baobmobile
                        ? _c(
                            "el-button",
                            {
                              attrs: { slot: "append" },
                              on: { click: _vm.unBindingBaob },
                              slot: "append"
                            },
                            [_vm._v("\n            取消绑定\n          ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("（数据同步时间：" + _vm._s(_vm.data_date) + "）")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "爆版店铺", prop: "shopId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "爆版店铺" },
                      model: {
                        value: _vm.form.shopId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shopId", $$v)
                        },
                        expression: "form.shopId"
                      }
                    },
                    _vm._l(_vm.shop_list, function(item) {
                      return _c("el-option", {
                        key: item.shopId,
                        attrs: { label: item.shopName, value: item.shopId }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.addShopVisible = true
                        }
                      }
                    },
                    [_vm._v("\n          新增店铺\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.form.supply_id
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.sycnWcgOrder }
                        },
                        [_vm._v("\n          同步一手欠货至爆版店铺\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.wcg_order_sync_time
                    ? _c("div", { staticStyle: { display: "inline" } }, [
                        _vm._v(
                          "\n          (同步时间: " +
                            _vm._s(_vm.form.wcg_order_sync_time) +
                            ")\n        "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否自主上款", prop: "is_self" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.form.open_deposit == "1",
                        placeholder: "是否自主上款"
                      },
                      model: {
                        value: _vm.form.is_self,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_self", $$v)
                        },
                        expression: "form.is_self"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "自主上款全类目", prop: "is_all_style" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.form.open_deposit == "1",
                        placeholder: "是否自主上款全类目"
                      },
                      model: {
                        value: _vm.form.is_all_style,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_all_style", $$v)
                        },
                        expression: "form.is_all_style"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "开通爆版开单", prop: "is_order_ability" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "是否开通爆版开单" },
                      model: {
                        value: _vm.form.is_order_ability,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_order_ability", $$v)
                        },
                        expression: "form.is_order_ability"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "开通库存共享", prop: "baob_stock_sharing" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "是否开通库存共享" },
                      model: {
                        value: _vm.form.baob_stock_sharing,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "baob_stock_sharing", $$v)
                        },
                        expression: "form.baob_stock_sharing"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v(" 提交 ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "添加店铺",
                    visible: _vm.addShopVisible,
                    width: "40%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.addShopVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "绑定账号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%", float: "left" },
                            model: {
                              value: _vm.form.baobmobile,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "baobmobile", $$v)
                              },
                              expression: "form.baobmobile"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺名称" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%", float: "left" },
                            model: {
                              value: _vm.form.shopName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shopName", $$v)
                              },
                              expression: "form.shopName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺地址" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%", float: "left" },
                            model: {
                              value: _vm.form.shopAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shopAddress", $$v)
                              },
                              expression: "form.shopAddress"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%", float: "left" },
                            model: {
                              value: _vm.form.shopPhone,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shopPhone", $$v)
                              },
                              expression: "form.shopPhone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.addShopVisible = false
                            }
                          }
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.AddShop }
                        },
                        [_vm._v(" 确 定 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.setag.show
            ? _c(
                "el-tab-pane",
                { attrs: { label: "商家分层权限", name: "setag" } },
                [
                  _c("div", [_vm._v("商家分层权限")]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      staticStyle: { margin: "30px" },
                      attrs: { model: _vm.setag.form }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "本月专场可上款数" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "160px" },
                            attrs: {
                              disabled: _vm.setag.form.none_limit == 1,
                              size: "samll"
                            },
                            model: {
                              value: _vm.setag.form.limit_num,
                              callback: function($$v) {
                                _vm.$set(_vm.setag.form, "limit_num", $$v)
                              },
                              expression: "setag.form.limit_num"
                            }
                          }),
                          _vm._v("    款\n          "),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "50px" },
                              attrs: { "true-label": "1", "false-label": "2" },
                              model: {
                                value: _vm.setag.form.none_limit,
                                callback: function($$v) {
                                  _vm.$set(_vm.setag.form, "none_limit", $$v)
                                },
                                expression: "setag.form.none_limit"
                              }
                            },
                            [_vm._v("\n            不限款数\n          ")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.submitSetag }
                            },
                            [_vm._v(" 提交 ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "小店分发设置", name: "setShop" } },
            [
              _c("StoreDistribute", {
                ref: "storeDistribute",
                attrs: { "supply-id": _vm.form.supply_id }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改商家等级",
            visible: _vm.addLevelVisible,
            width: "40%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addLevelVisible = $event
            }
          }
        },
        [
          _c("p", [_vm._v("修改后只对当前自然月生效")]),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.update_sale_level,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "update_sale_level", $$v)
                    },
                    expression: "form.update_sale_level"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: -1 } }, [
                    _vm._v(" 不设置等级 ")
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v(" L0 ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v(" L1 ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v(" L2 ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 3 } }, [_vm._v(" L3 ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 4 } }, [_vm._v(" L4 ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 5 } }, [_vm._v(" L5 ")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 6 } }, [_vm._v(" L6 ")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.addLevelVisible = false
                    }
                  }
                },
                [_vm._v(" 取 消 ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateSaleLevel }
                },
                [_vm._v(" 确 定 ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("preview-image", {
        attrs: { imgs: _vm.dialogImageUrl, show: _vm.dialogVisible },
        on: {
          closeBox: function($event) {
            _vm.dialogVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowModalInvitationRule,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowModalInvitationRule = $event
            },
            close: _vm.handleInvitationModalClose
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "invitation-modal-header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c("span", { staticClass: "invitation-modal-title" }, [
                _vm._v("编辑商家邀约规则")
              ]),
              _vm._v(" "),
              _c("el-switch", {
                staticStyle: { display: "block" },
                attrs: {
                  "active-value": "2",
                  "inactive-value": "1",
                  "active-text": "新规",
                  "inactive-text": "旧规"
                },
                model: {
                  value: _vm.invitationForm.rule_type,
                  callback: function($$v) {
                    _vm.$set(_vm.invitationForm, "rule_type", $$v)
                  },
                  expression: "invitationForm.rule_type"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "invitationForm",
              attrs: { model: _vm.invitationForm, size: "mini" }
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.invitationForm.list,
                    border: "",
                    size: "mini"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "invitation_category",
                      align: "center",
                      label: "商品分类"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "list." + $index + ".invitation_category",
                                rules: { required: true, message: "必选" }
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: row.invitation_category,
                                    callback: function($$v) {
                                      _vm.$set(row, "invitation_category", $$v)
                                    },
                                    expression: "row.invitation_category"
                                  }
                                },
                                _vm._l(_vm.invitationRule.category, function(
                                  option
                                ) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: option.value,
                                      attrs: { value: option.value }
                                    },
                                    [_vm._v(_vm._s(option.label))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "forecast_days",
                      align: "center",
                      label: "前置仓备货天数"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "list." + $index + ".forecast_days"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { clearable: "" },
                                  model: {
                                    value: row.forecast_days,
                                    callback: function($$v) {
                                      _vm.$set(row, "forecast_days", $$v)
                                    },
                                    expression: "row.forecast_days"
                                  }
                                },
                                _vm._l(_vm.invitationRule.forecastDay, function(
                                  option
                                ) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: option.value,
                                      attrs: { value: option.value }
                                    },
                                    [_vm._v(_vm._s(option.label))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "is_underwriting",
                      align: "center",
                      label: "是否加流"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "list." + $index + ".is_underwriting"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    "true-label": _vm.constantMap.OPEN,
                                    "false-label": _vm.constantMap.CLOSE
                                  },
                                  model: {
                                    value: row.is_underwriting,
                                    callback: function($$v) {
                                      _vm.$set(row, "is_underwriting", $$v)
                                    },
                                    expression: "row.is_underwriting"
                                  }
                                },
                                [_vm._v("是否加流")]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "no_pre_storage_forecast_days",
                      align: "center",
                      label: "非前置仓备货天数"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "list." +
                                  $index +
                                  ".no_pre_storage_forecast_days"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { clearable: "" },
                                  model: {
                                    value: row.no_pre_storage_forecast_days,
                                    callback: function($$v) {
                                      _vm.$set(
                                        row,
                                        "no_pre_storage_forecast_days",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "row.no_pre_storage_forecast_days"
                                  }
                                },
                                _vm._l(
                                  _vm.invitationRule.noPreStorageForecastDay,
                                  function(option) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: option.value,
                                        attrs: { value: option.value }
                                      },
                                      [_vm._v(_vm._s(option.label))]
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "actions", align: "center", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var $index = ref.$index
                          return _c(
                            "el-form-item",
                            {},
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleInvitationRuleDel($index)
                                    }
                                  }
                                },
                                [_vm._v("\n              删除\n            ")]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "", size: "medium" },
              on: { click: _vm.handleInvitationRuleAdd }
            },
            [_vm._v("\n      新增规则\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingInvitationSave },
                  on: {
                    click: function($event) {
                      _vm.isShowModalInvitationRule = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loadingInvitationSave,
                    type: "primary"
                  },
                  on: { click: _vm.handleInvitationRuleSave }
                },
                [_vm._v("\n        保存\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fad7584", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fad7584","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/UpdateSupply.vue
// module id = null
// module chunks = 